export default __webpack_public_path__ + "static/background-hero-home-inter-asset-sm-1ce9ec62e7ae15c088ec2d7c760cc563.png";